export var GameType;
(function (GameType) {
    /**
     * VR 彩票
     */
    GameType[GameType["VR_LOTTERY"] = 201] = "VR_LOTTERY";
    /**
     * OG 真人
     */
    GameType[GameType["OG_LIVE"] = 301] = "OG_LIVE";
    /**
     * AE 电子
     */
    GameType[GameType["AE_VIDEO"] = 401] = "AE_VIDEO";
    /**
     * BBIN 真人
     */
    GameType[GameType["BBIN_LIVE"] = 501] = "BBIN_LIVE";
    /**
     * DT 电子
     */
    GameType[GameType["DT_VIDEO"] = 601] = "DT_VIDEO";
    /**
     * JDB 电子
     */
    GameType[GameType["JDB_VIDEO"] = 701] = "JDB_VIDEO";
    /**
     * IM 体育
     */
    GameType[GameType["IM_SPORT"] = 901] = "IM_SPORT";
    /**
     * IM 电竞
     */
    GameType[GameType["IM_ESPORT"] = 902] = "IM_ESPORT";
    /**
     * 开元棋牌
     */
    GameType[GameType["KY_CARD"] = 1001] = "KY_CARD";
    /**
     * 开元捕魚
     */
    GameType[GameType["KY_FISH"] = 1002] = "KY_FISH";
    /**
     * 泛亚电竞（开心电竞）
     */
    GameType[GameType["AVIA_ESPORT"] = 1101] = "AVIA_ESPORT";
    /**
     * 沙巴体育
     */
    GameType[GameType["SABA_SPORT"] = 1201] = "SABA_SPORT";
    /**
     * 欧博真人
     */
    GameType[GameType["AB_LIVE"] = 1301] = "AB_LIVE";
    /**
     * PA 真人
     */
    GameType[GameType["PA_LIVE"] = 1401] = "PA_LIVE";
    /**
     * PA 電子
     */
    GameType[GameType["PA_VIDEO"] = 1402] = "PA_VIDEO";
    /**
     * PA 捕魚
     */
    GameType[GameType["PA_FISH"] = 1403] = "PA_FISH";
    /**
     * CQ9 电子
     */
    GameType[GameType["CQ9_VIDEO"] = 1501] = "CQ9_VIDEO";
    /**
     * CQ9 捕魚
     */
    GameType[GameType["CQ9_FISH"] = 1502] = "CQ9_FISH";
    /**
     * eBET 真人
     */
    GameType[GameType["EBET_LIVE"] = 1601] = "EBET_LIVE";
    /**
     * 皇冠體育 (黃金甲體育)
     */
    GameType[GameType["CROWN_SPORT"] = 1701] = "CROWN_SPORT";
    /**
     * 凱旋棋牌 (GA 棋牌)
     */
    GameType[GameType["KX_CARD"] = 1801] = "KX_CARD";
    /**
     * 小艾電競
     */
    GameType[GameType["ILUSTRE_ESPORT"] = 1901] = "ILUSTRE_ESPORT";
    /**
     * 雷火電競 (GA 電競)
     */
    GameType[GameType["TF_ESPORT"] = 2001] = "TF_ESPORT";
    /**
     * BTI 體育
     */
    GameType[GameType["BTI_SPORT"] = 2101] = "BTI_SPORT";
    /**
     * 高登棋牌
     */
    GameType[GameType["GF_CARD"] = 2201] = "GF_CARD";
    /**
     * FC 發財電子
     */
    GameType[GameType["FC_VIDEO"] = 2301] = "FC_VIDEO";
    /**
     * AI 体育
     */
    GameType[GameType["AI_SPORT"] = 2401] = "AI_SPORT";
    /**
     * 雙贏彩票
     */
    GameType[GameType["SGWIN_LOTTERY"] = 2501] = "SGWIN_LOTTERY";
    /**
     * KG 真人
     */
    GameType[GameType["KG_LIVE"] = 2601] = "KG_LIVE";
    /**
     * 保利體育
     */
    GameType[GameType["POLY_SPORT"] = 2701] = "POLY_SPORT";
    /**
     * KS 棋牌
     */
    GameType[GameType["KS_CARD"] = 2801] = "KS_CARD";
    /**
     * BG 真人
     */
    GameType[GameType["BG_LIVE"] = 2901] = "BG_LIVE";
    /**
     * PG 電子
     */
    GameType[GameType["PG_VIDEO"] = 3001] = "PG_VIDEO";
    /**
     * PP 電子
     */
    GameType[GameType["PP_VIDEO"] = 3101] = "PP_VIDEO";
    /**
     * FB 體育
     */
    GameType[GameType["FB_SPORT"] = 3201] = "FB_SPORT";
    /**
     * 熊貓體育（PM 體育）
     */
    GameType[GameType["PM_SPORT"] = 3301] = "PM_SPORT";
    /**
     * DB 真人
    */
    GameType[GameType["DB_LIVE"] = 3401] = "DB_LIVE";
    /**
     * * DB 電競
     */
    GameType[GameType["DB2_ESPORT"] = 3501] = "DB2_ESPORT";
    /**
     * GoldenSport
    */
    GameType[GameType["GOLDEN_SPORT"] = 299] = "GOLDEN_SPORT";
})(GameType || (GameType = {}));
//# sourceMappingURL=GameType.js.map